import { Injectable } from '@angular/core';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { HttpRepo } from '@shared/services/httprepo';

@Injectable({
  providedIn: 'root'
})
export class ImportDataService {

  constructor(private auth: AuthService, private httpRepo: HttpRepo) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
  }

  public UploadFile(entityId,formData){
    return this.httpRepo.PostFile("import/"+entityId,formData) // Send the state to the server
  }
  public ProcessFile(formData){
    return this.httpRepo.Post("import/process",formData);
  }
}
